export const sessionData = (data: Record<string, string>) => {
  window.Beacon?.('session-data', data);
};
